// ======================================================================
// File Name       : DistributionOfferInfo
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, Button } from 'react-bootstrap';
import SelectBox from '../SelectBox';
import { convertNodeGroupToNodeString } from '../../utils/UserUtils';
import * as MessageTemplate from '../../constants/MessageTemplate';
import FormControlValidate from '../../components/FormControlValidate';
import { VALIDATE_TYPE } from '../../constants/index';
import { DISTRIBUTION_OFFER_TYPE } from '../../constants/ContentConstant';

const DistributionOfferInfo = ({
  offerType,
  handleChange,
  onShowSelectionListBtnClick,
  disabledButton,
  removeAllDistributionCourseOrContentFromList,
  isDistributionContent,
}) => (
  <div className="margin-top-10" >
    <Form className='form-horizontal' style={{ display: 'flow-root' }}>
      <Form.Group className="form-info" controlId="formHorizontalShowPopup">
        <Col sm={12}>
          <Col sm={8} as={Form.Label}>
            <span className="padding-left-35">
              {(offerType === DISTRIBUTION_OFFER_TYPE.CONTENT) ?
                '配布コンテンツ一覧' : '配布コース一覧'}
            </span>
            <Button
              variant="primary"
              className="btn-96 margin-left-10"
              onClick={onShowSelectionListBtnClick.bind(this)}
              disabled={disabledButton}
            >
                追加
            </Button>
          </Col>
          <Col sm={4} className="text-right padding-clear margin-top-10">
            <Button variant="default" onClick={() => { removeAllDistributionCourseOrContentFromList(isDistributionContent); }}>
              {isDistributionContent ? 'コンテンツ一括削除' : 'コース一括削除'}
            </Button>
          </Col>
        </Col>
      </Form.Group>
    </Form>
  </div>
  );

export default DistributionOfferInfo;
